// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__2CEys","content":"PrivacyPolicyPage_content__KFVsy"};